import { Spinner } from 'components';
import React from 'react';
import styled from 'styled-components';
import { PropTypes } from 'prop-types';
export const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10;
  background-color: rgba(255, 255, 255, 0.75) !important;
`;

export default function RequestPendingSpinner({ style, color, isActive }) {
  if (!isActive) {
    return null;
  }

  return (
    <SpinnerWrapper>
      <Spinner style={style} color={color} />
    </SpinnerWrapper>
  );
}

RequestPendingSpinner.propTypes = {
  style: PropTypes.object,
  color: PropTypes.string,
  isActive: PropTypes.bool,
};
